<template>
  <div class="text-left text-gray-800">
      <p class="mb-6 font-semibold">
        Welcome to Screened
      </p>

      <p class="mb-6 font-semibold">
        You're all set.
      </p>

      <p class="mb-6">
        Screened helps you stay informed about opportunities, employers and hiring activity relevant to your career.
        <br>
        Inside your dashboard you'll find:
      </p>

      <ul class="mb-6 space-y-1">
        <li>📈 Active opportunities in your field</li>
        <li>🏢 Companies currently hiring</li>
        <li>⛏️ Projects that may drive future hiring demand</li>
        <li>📊 Market insights tailored to your experience and location</li>
      </ul>

      <p class="mb-6">
        <span class="font-semibold">Log in</span> to view <span class="font-semibold">your personalised dashboard.</span>
      </p>

      <div class="text-center">
        <router-link
          to="/contractor/profile"
          class="inline-flex items-center justify-center rounded-md bg-brand px-6 py-3 font-semibold text-white shadow-lg shadow-brand/20 transition duration-150 ease-in-out hover:bg-brand/90 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand/40"
        >
          Go to Dashboard
        </router-link>
      </div>
  </div>
</template>

<script>
export default {
  name: 'ThankYou'
};
</script>

<style scoped>
/* You can reuse existing styles or add specific ones */
</style>
